

import axios from "axios";
import { getToken } from "../helpers/token.helper";

export const cbHttp = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL });

cbHttp.interceptors.request.use(
    (config) => {

        // CodeIgniter uses application/x-www-form-urlencoded
        // to retrieve request data using $request->getPost()
        // PUT, PATCH, DELETE requests require raw data processing
        // https://codeigniter4.github.io/CodeIgniter4/incoming/incomingrequest.html#retrieving-raw-data-put-patch-delete
        const token = getToken();

        if (token?.length > 0 && config.headers.Authorization === undefined) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        config.timeout = (1000 * (60 * 60)) // Default 60 minute timeout

        if (config.method === "post") {

            if (!(config.data instanceof FormData)) {
                // Only set Content-Type if not already explicitly set
                if (!config.headers["Content-Type"]) {
                    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
                }

                // Only convert to URLSearchParams if Content-Type is form-urlencoded
                if (config.headers["Content-Type"] === "application/x-www-form-urlencoded") {
                    config.data = new URLSearchParams(config.data).toString();
                }
            }
        }

        return config;
    }
);

cbHttp.interceptors.response.use(
    (response) => {
        return response?.data ?? response;
    },
    (error) => {
        const message = error?.response?.data?.message ?? "";
        if (message === "Unauthorized Request") {
            location.href = location.origin + "/login";
            console.clear();
        } else {
            return Promise.reject(error);
        }
    }
)